/**
 * 文件说明:
 * ----------------------------------------
 * 创建用户: 1625 [zhanghedong@gmail.com]
 * 创建日期: 2022/8/8
 */
import { useCallback, useEffect, useRef, useState } from "react"
import { Card, Toast, Button, Empty, Tag } from 'antd-mobile'
import api from "../../api"
import styles from './index.module.less'
import { useNavigate } from "react-router-dom"
import constant from '../../constants'

function Index(props) {
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const [list, setList] = useState([])
    const toast = useRef(null)
    const loadZones = useCallback(async () => {
        setLoading(true)
        toast.current = Toast.show({
            icon: 'loading',
            content: '加载中...',
            duration: 0
        })
        const res = await api.getOrgStaffs({ order_by: 'role_id' })
        if (res.meta.code === 200) {
            setList(res.data)
        } else {

        }
        toast.current.close()
        setLoading(false)
    }, [])

    const handleEdit = useCallback(async (_id) => {
        navigate(`/staffs/edit?id=${_id}`)
    }, [navigate])


    useEffect(() => {
        loadZones()
    }, [])
    return <div className={styles.zones}>
        <div className={styles.action}>
            <Button size="small" onClick={() => {
                navigate('/staffs/add')
            }}>添加</Button>
        </div>
        {list.map((_item) => {
            return <Card title={`${_item.name}   ${_item.mobile}`} key={_item.id} onClick={() => {
                handleEdit(_item.id)
            }} className={styles.card}
                         extra={<Tag color="primary" fill="outline">{constant.roleKV[_item?.role_id]}</Tag>}>
                <div className={styles.content}>
                    <span>{_item.zone?.name}</span>
                </div>
            </Card>
        })}
        {!loading && !list.length ? <><Empty description="暂无数据" /></> : ''}
    </div>
}

export default Index
